export default __webpack_public_path__ + "static/media/Drones_02.0932ba78.png";